import styled from "styled-components";

export const Title = styled.h1`
  font-size: 32px;
  font-weight: bold;

  margin-bottom: 24px;
`;
